import { resolvePeriods, resolvePeriod } from './resolvers/periods.resolver';

export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app.admin.periods', {
      url: '/periods',
      component: 'periodsList',
      resolve: {
        periods: resolvePeriods(-1),
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.deletedperiods', {
      url: '/periods/deleted',
      component: 'periodsList',
      resolve: {
        periods: resolvePeriods(-1, 0, 'deleted')
      },
      roles: [ 'admin' ]
    })
    .state('app.admin.period-add', {
      url: '/periods/create',
      component: 'periodsSave',
      resolve: {
        title: () => 'Create a Period'
      },
      roles: [ 'manager' ]
    })
    .state('app.admin.period-edit', {
      url: '/periods/:period/update?tab',
      component: 'periodsSave',
      resolve: {
        title: () => 'Update a Period',
        period: resolvePeriod()
      },
      roles: [ 'manager' ]
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/periods.routes.js